// extracted by mini-css-extract-plugin
export default {"nodata":"style_nodata__GFhlA","nodatatext":"style_nodatatext__sIQec","margin":"style_margin__CdhLO"};